// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__4TXNT","header_with_title":"modal_header_with_title__kXDJy","header_without_title":"modal_header_without_title__aQaQj","close_icon":"modal_close_icon__X5UC+"};